module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUoAAADGAgMAAADJQiGBAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEX///8Alm7WJhJCjUAzAAAAAWJLR0QAiAUdSAAAAAd0SU1FB+oDDwkoECvzfYMAAABRSURBVHja7cwxDQAwCAAwJO7BH/dUzgIkJHtaAY0AAAAAAOCrXHecTqfT6XQ6nU6n0+l0Op1Op9M5OO+6cjqdTqfT6XQ6nU6n0+l0Op1OZ/98N5pN+HiWy0UAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjYtMDMtMTVUMDk6NDA6MTYrMDA6MDC48uBAAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDI2LTAzLTE1VDA5OjQwOjE2KzAwOjAwya9Y/AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/bjly.png
// module id = XnlN
// module chunks = 128